





































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class Field extends Vue {
  @Prop()
  private readonly label?: any;

  @Prop()
  private readonly tooltip?: any;

  @Prop()
  private readonly action?: any;

  @Prop()
  private readonly actionClick?: any;

  @Prop()
  private readonly className?: string;

  private get fieldActionEvents() {
    return {
      ...this.actionClick && { click: this.actionClick },
    };
  }
}
